// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uQrt","newExpiryDate":"styles_newExpiryDate__1O5Af","footer":"styles_footer__1ieI7"};